import React from "react";
import { Helmet } from "react-helmet";
import Error404Img from "../assets/images/svg/error404.svg";
import ButtonLink from "../components/elements/ButtonLink";
import HeaderNavigation from "../components/layout/HeaderNavigation";

const Error404 = ({ content, linkName, linkUrl }) => {
  return (
    <>
      <Helmet>
        <title>Utiva | Error</title>
      </Helmet>
      <HeaderNavigation />
      <div className="min-h-full mt-32 mx-auto grid grid-cols-1 grid-rows-1 items-center">
        <div className="container mx-auto text-center relative px-4 lg:w-6/12">
          <img
            src={Error404Img}
            className="mx-auto"
            width="50%"
            alt="Error 404"
          />
          <p className="pt-10 font-light text-default text-base md:text-xl leading-7 tracking-wide">
            {content || (
              <>
                Oops! The page you are looking for does not exist.
                <br />
                We are currently working on it. Do check back
              </>
            )}
          </p>

          <div className="mt-14">
            <ButtonLink
              url={linkUrl || "/courses"}
              title={linkName || "View our courses"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Error404;
